import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";

var _this = this;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

export var useKeyMap = function useKeyMap(
/**
 * The Key that was pressed.
 */
event,
/**
 * keyMap: Should be an object looking like:
 * {
 *  [Key.ArrowUp]: values => {
 *      what you wanna do
 *      you can use values.next, values.prev [...] to get according values from the value list/map you passed via the values prop
 *  }
 * }
 */
keyMap, focusHandler) {
  _newArrowCheck(this, _this);

  if (Object.keys(keyMap).includes(event.key)) {
    var keyHandler = keyMap[event.key];

    if (keyHandler.fn) {
      var keyHandlerObj = keyHandler;

      if ((!event.shiftKey || keyHandlerObj.allowShift) && (!event.ctrlKey || keyHandlerObj.allowCtrl) && (!event.altKey || keyHandlerObj.allowAlt)) {
        keyHandlerObj.fn(focusHandler);

        if (!keyHandlerObj.noPreventDefault) {
          event.preventDefault();
        }
      }
    } else {
      var keyHandlerFn = keyHandler;

      if (!event.shiftKey && !event.ctrlKey && !event.altKey) {
        keyHandlerFn(focusHandler);
        event.preventDefault();
      }
    }
  }
}.bind(this);
export var getFocusHandler = function getFocusHandler(
/**
 * Pass an array of values (example: Accordion, SelectDropdown) or a map (array of array) of values (example: Header).
 * You can then get next/prev/above/below/first/last values inside the functions you provide for each key via keyMap prop.
 */
values,
/**
 * Pass the currently active value - this has to be an element within values.
 */
activeValue) {
  var _this2 = this;

  _newArrowCheck(this, _this);

  if (values && activeValue) {
    var is2D = Array.isArray(values[0]);
    var vals1D = values;
    var vals2D = values;

    var getActiveCoords = function getActiveCoords() {
      var _this3 = this;

      _newArrowCheck(this, _this2);

      if (is2D) {
        var y = vals2D.findIndex(function (val) {
          _newArrowCheck(this, _this3);

          return val.includes(activeValue);
        }.bind(this));
        return [vals2D[y].findIndex(function (val) {
          _newArrowCheck(this, _this3);

          return val === activeValue;
        }.bind(this)), y];
      }

      return [vals1D.findIndex(function (val) {
        _newArrowCheck(this, _this3);

        return val === activeValue;
      }.bind(this)), 0];
    }.bind(this);

    return !is2D ? {
      curr: function curr() {
        _newArrowCheck(this, _this2);

        return activeValue;
      }.bind(this),
      first: function first() {
        _newArrowCheck(this, _this2);

        return vals1D[0];
      }.bind(this),
      last: function last() {
        _newArrowCheck(this, _this2);

        return vals1D.slice(-1)[0];
      }.bind(this),
      next: function next(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords = getActiveCoords(),
            _getActiveCoords2 = _slicedToArray(_getActiveCoords, 1),
            i = _getActiveCoords2[0];

        var isLast = i === vals1D.length - 1;
        var newIndex = isLast ? 0 : i + 1;
        return isLast && cb ? cb() : vals1D[newIndex];
      }.bind(this),
      prev: function prev(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords3 = getActiveCoords(),
            _getActiveCoords4 = _slicedToArray(_getActiveCoords3, 1),
            i = _getActiveCoords4[0];

        var isFirst = i === 0;
        var newIndex = isFirst ? vals1D.length - 1 : i - 1;
        return isFirst && cb ? cb() : vals1D[newIndex];
      }.bind(this)
    } : {
      curr: function curr() {
        _newArrowCheck(this, _this2);

        return activeValue;
      }.bind(this),
      first: function first() {
        var _this4 = this;

        _newArrowCheck(this, _this2);

        return vals2D[0].find(function (vals) {
          _newArrowCheck(this, _this4);

          return vals;
        }.bind(this));
      }.bind(this),
      last: function last() {
        _newArrowCheck(this, _this2);

        var lastY = vals2D.length - 1;
        var lastX = vals2D[lastY].length - 1;
        return vals2D[lastY][lastX];
      }.bind(this),
      next: function next(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords5 = getActiveCoords(),
            _getActiveCoords6 = _slicedToArray(_getActiveCoords5, 2),
            x = _getActiveCoords6[0],
            y = _getActiveCoords6[1];

        var lineBelow = vals2D[y + 1];

        if (x + 1 < vals2D[y].length) {
          return vals2D[y][x + 1];
        }

        if (x + 1 >= vals2D[y].length - 1 && lineBelow && lineBelow[0]) {
          return lineBelow[0];
        }

        cb();
        return;
      }.bind(this),
      prev: function prev(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords7 = getActiveCoords(),
            _getActiveCoords8 = _slicedToArray(_getActiveCoords7, 2),
            x = _getActiveCoords8[0],
            y = _getActiveCoords8[1];

        var lineAbove = vals2D[y - 1];

        if (x - 1 >= 0 && vals2D[y][x - 1]) {
          return vals2D[y][x - 1];
        }

        if (x - 1 < 0 && lineAbove && lineAbove[lineAbove.length - 1]) {
          return lineAbove[lineAbove.length - 1];
        }

        cb();
        return;
      }.bind(this),
      above: function above(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords9 = getActiveCoords(),
            _getActiveCoords10 = _slicedToArray(_getActiveCoords9, 2),
            x = _getActiveCoords10[0],
            y = _getActiveCoords10[1];

        var lineAbove = vals2D[y - 1];

        if (lineAbove && lineAbove[x]) {
          return lineAbove[x];
        }

        cb();
        return;
      }.bind(this),
      below: function below(cb) {
        _newArrowCheck(this, _this2);

        var _getActiveCoords11 = getActiveCoords(),
            _getActiveCoords12 = _slicedToArray(_getActiveCoords11, 2),
            x = _getActiveCoords12[0],
            y = _getActiveCoords12[1];

        var lineBelow = vals2D[y + 1];

        if (lineBelow && lineBelow[x]) {
          return lineBelow[x];
        }

        cb();
        return;
      }.bind(this)
    };
  }
}.bind(this);